<template>
  <sc-page-base
    title="Logs"
    subTitle="Os resultados serão limitados ao que for encontrado apenas nos últimos 10 dias. Para buscas utilizando um id de cotação, será exibido o resultado encontrado dentro dos últimos 30 dias.">
    <div class="box">
      <sc-logs-api-filters />
    </div>

    <div class="box">
      <sc-tabs>
        <sc-tab-item
          label="Últimas 10 chamadas">
          <sc-logs-api-list-all />
        </sc-tab-item>

        <sc-tab-item
          label="Últimas 10 chamadas com erros">
          <sc-logs-api-list-errors />
        </sc-tab-item>
      </sc-tabs>
    </div>
  </sc-page-base>
</template>

<script>
  import {
    ScPageBase,
    ScTabs,
    ScTabItem,
  } from '@intelipost-js/secure-components';

  import ScLogsApiFilters from './components/sc-logs-api-filters/ScLogsApiFilters';
  import ScLogsApiListAll from './components/sc-logs-api-list-all/ScLogsApiListAll';
  import ScLogsApiListErrors from './components/sc-logs-api-list-errors/ScLogsApiListErrors';

  export default {
    name: 'page-logs-api',
    components: {
      ScPageBase,
      ScTabs,
      ScTabItem,
      ScLogsApiFilters,
      ScLogsApiListAll,
      ScLogsApiListErrors,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/logs/pages/api/PageLogsApi.vue